import React from "react";
import "../container.css";
import { useHistory } from "react-router-dom";

export default function Event({ event, imageHeight, textEllipse }) {
  const history = useHistory();

  const eventDetails = () => {
    history.push(`/dashboard/user/event/${event.id}`);
  };

  return (
    <div
      className="rounded card_shadow cursor-pointer md:border"
      onClick={() => eventDetails()}
    >
      <img
        className={`object-fill w-full h-32 md:h-72`}
        src={event.imageUrl}
        alt="Event image"
        loading="lazy"
      />
      <div className="p-1 md:p-4">
        <div className="text-xs mb-2">{event.noOfAttendees} Participants</div>
        <div className="font-bold">{event.name}</div>
        <div className={`text-xs mb-2 ${textEllipse} w-48 md:w-full`}>
          {event.description}
        </div>
        <div className="">
          <span className="text-xs text-gray-400">{event.eventCategory}</span>
        </div>
      </div>
    </div>
  );
}
